import React, { useEffect, useRef } from "react";
import { LGTVInfo, LGDeviceID } from "./LtvInfo";
// import { fetchContent } from "../services/api";
import logo from "../assets/logo.png";
import splashvideo from "../assets/splashvideo.mp4";
import { getCountryByCDN, getData, getMasterHit, getMasterHitV2 } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import {DeviceManager} from "../globalManager/DeviceManager";
import { LibraryManager } from "../globalManager/LibraryManager";
import VidaaTVInfo from "./Vidaa";
// import { LogManager } from "../globalManager/LogManagers";

let resolution = window.RESOLUTION;
let cwpooling = window.CWPOOLING;
let teaser_countdown = window.TEASER_COUNTDOWN;

const SplashScreen = ({ splashComplete, screenName }) => {
  const videoRef = useRef(null);
  const getsCountry = localStorage.getItem("country");

  const loadData = async () => {
    let headers = {
      iskid: "0",
      age: "0",
      country_name: getsCountry,
      Langid: "1",
      "Content-Type": "application/json",
    };
    try {
      // Fetch banner and grid data simultaneously
      // const response = await fetchContent("/V1/getMasterHit", "GET", headers);

      const response = await getMasterHit()
      console.log("master Data....", response);

      const filteredData = response?.data?.ads_settings?.filter(item => item.platform_id === window.DEVICE_TYPE);
      const vodData = filteredData?.find(item => item.content_type === "VOD");
      const aodData = filteredData?.find(item => item.content_type === "AOD");

      localStorage.setItem("AOD_AD_Setting", JSON.stringify(aodData));
      localStorage.setItem("VOD_AD_Setting", JSON.stringify(vodData));
      // Matomo Event
      sendTestMatomoEvent({ eventCategory: "App", eventAction: "Start" });
      cwpooling = response?.data?.cwpooling;
      teaser_countdown = response?.data?.teaser_countdown;
      window.CWPOOLING = cwpooling;
      window.TEASER_COUNTDOWN = teaser_countdown;
      console.log("cwpooling....", cwpooling, window.CWPOOLING);
      localStorage.setItem("masterData", JSON.stringify(response));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getTvData = async () => {
    try {
      const response = await getData();
      console.log(response, "response");
      localStorage.setItem("LogCapture", response?.data?.log_capture);
      localStorage.setItem("LogUrl", response?.data?.log_url);
      localStorage.setItem("userID", crypto.randomUUID());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // const getCountry = async () => {
  //   try {
  //     // Fetch banner and grid data simultaneously
  //     // const response = await fetchContent("/V1/getCountryByCDN", "GET");

  //     const response = await getCountryByCDN();
  //     console.log("master Data..country..", response);
  //     localStorage.setItem("country", response?.data?.country);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const getCountry = async () => {
    try {
      const response = await getCountryByCDN();
      console.log("master Data..country..", response);

      // 👀 Check response structure before saving
      // Example: response might look like:
      // { data: { country: "IN" } }
      // or maybe { country: "IN" }

      const country =
        response?.data?.country || response?.country || null;

      if (country) {
        console.log("Detected country:", country);
        localStorage.setItem("country", country);
      } else {
        console.warn("Country not found in response:", response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const tvDetails = () => {
     localStorage.removeItem("NewmobileNo")
       console.log("samsung app useEffect splash");
    window.deviceManager = new DeviceManager();
    window.libraryManager = new LibraryManager();
    if (window.deviceManager.isSamsung()) {
      console.log("samsung app useEffect....splash");
      window.deviceManager.initTizenAPI();
    }else if (window.deviceManager.isLG()) {
      console.log("LG app useEffect");
      // LG webOS
      window.deviceManager.initWebOSAPI();
    }
  }

  const StartSound = () => {
    videoRef.current.muted = false;
    const timer = setTimeout(() => {
      loadData();
      clearTimeout(timer);
      splashComplete();
      getTvData();
      tvDetails();
    }, 4000); // 5 seconds delay
    getCountry();
  };

  //  useEffect(() => {
  //   console.log("samsung app useEffect splash");
  //   window.deviceManager = new DeviceManager();
  //   window.libraryManager = new LibraryManager();
  //   if (window.deviceManager.isSamsung()) {
  //     console.log("samsung app useEffect....splash");
  //     window.deviceManager.initTizenAPI();
  //   }else if (window.deviceManager.isLG()) {
  //     console.log("LG app useEffect");
  //     // LG webOS
  //     window.deviceManager.initWebOSAPI();
  //   }
  //   // LogManager();
  // }, []);

  // useEffect(() => {
  //   loadData();
  //   const timer = setTimeout(() => {
  //     navigate(screenName);
  //   }, 5000); // 5 seconds delay

  //   return () => clearTimeout(timer); // Cleanup timer
  // }, [navigate]);

  return (
    <div>
      <div style={styles.splashContainer}>
        {/* <img style={styles.Logo} src={logo} alt="Logo" /> */}
        {/* <video style={styles.Logo} src={splashvideo} autoPlay loop muted playsInline/> */}
        <video
          style={styles.Logo}
          ref={videoRef}
          src={splashvideo}
          onLoadedData={StartSound}
          autoPlay
          muted
          loop
          playsInline
        />
      </div>
      <VidaaTVInfo/>
    </div>
  );
};

const styles = {
  splashContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#000000",
  },
  Logo: {
    width: resolution === "FHD" ? "1920px" : "1920px",
    height: resolution === "FHD" ? "1080px" : "1080px",
  },
};

export default SplashScreen;

// import React, { useEffect, useRef, useState } from "react";
// import { LGTVInfo, LGDeviceID } from "./LtvInfo";
// import { fetchContent } from "../services/api";
// import logo from "../assets/logo.png";
// import splashvideo from "../assets/splashvideo.mp4";

// let resolution = window.RESOLUTION;

// const SplashScreen = ({ navigate, screenName }) => {
//   const videoRef = useRef(null); // Ref to access the video element
//   const [videoReady, setVideoReady] = useState(false); // State to track video readiness

//   const loadData = async () => {
//     let headers = {
//       iskid: "0",
//       age: "0",
//       country_name: "India",
//       Langid: "1",
//       "Content-Type": "application/json",
//     };

//     try {
//       // Fetch banner and grid data simultaneously
//       const response = await fetchContent("/V1/getMasterHit", "GET", headers);
//       console.log("master Data....", response);
//       localStorage.setItem("masterData", JSON.stringify(response));
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   // Start playing video with sound after user interaction
//   const handleUserInteraction = () => {
//     if (videoRef.current) {
//       videoRef.current.muted = false; // Unmute the video when the user interacts
//       videoRef.current.play(); // Start playing with sound
//       setVideoReady(true); // Set video as ready to play with sound
//     }
//   };

//   useEffect(() => {
//     loadData();

//     // Set up a timer to navigate to the next screen
//     const timer = setTimeout(() => {
//       navigate(screenName);
//     }, 5000); // 5 seconds delay

//     // Cleanup function
//     return () => {
//       clearTimeout(timer); // Cleanup the navigate timer
//     };
//   }, [navigate, screenName]);

//   return (
//     <div>
//       <div
//         style={styles.splashContainer}
//         onClick={handleUserInteraction} // Trigger unmute and play on click
//       >
//         {/* <img style={styles.Logo} src={logo} alt="Logo" /> */}
//         <video
//           ref={videoRef}
//           style={styles.Logo}
//           src={splashvideo}
//           autoPlay
//           loop
//           muted // Start muted to comply with autoplay policies
//           playsInline
//         />
//       </div>
//       <LGDeviceID />
//       <LGTVInfo />
//     </div>
//   );
// };

// const styles = {
//   splashContainer: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     height: "100vh",
//     objectFit: "cover",
//     backgroundColor: "#000000",
//     cursor: "pointer", // Indicates clickable area
//   },
//   Logo: {
//     width: resolution === "FHD" ? "1920px" : "1920px",
//     height: resolution === "FHD" ? "1080px" : "1080px",
//   },
// };

// export default SplashScreen;